import { createEntityManagementRoutes, createPageRoute } from '@lumapps/router';
import { AppId } from '@lumapps/router/constants';

export const surveysRouteSlug = 'surveys';

export const surveysRoute = createPageRoute({
    slug: surveysRouteSlug,
    appId: AppId.backOffice,
});

const surveysBroadcastRouteSlug = `${surveysRouteSlug}/:surveyId/broadcasts`;

/**
 * Create all basic routes and getters needed on surveys broadcasts page
 * - /surveys/:surveyId/broadcasts (base)
 * - /surveys/:surveyId/broadcasts/create
 * - /surveys/:surveyId/broadcasts/:id (broadcast view)
 * - /surveys/:surveyId/broadcasts/:id/edit
 * All routes are included natively (base, create, view, edit)
 */
export const surveysBroadcastRoutes = createEntityManagementRoutes({
    appId: AppId.backOffice,
    slug: surveysBroadcastRouteSlug,
});
